import React from "react";

const MaskedNationalId = ({
  maskedValue,
  value,
  loading,
  onToggle,
  text
}) => {
  const revealed = Boolean(value);
  const label = revealed ? text.hideNationalId : text.showNationalId;

  return (
    <span className="masked-national-id">
      <bdi>{value || maskedValue || "—"}</bdi>
      <button
        type="button"
        aria-label={label}
        title={label}
        disabled={loading}
        onClick={onToggle}
      >
        <i
          className={`fa-regular ${revealed ? "fa-eye-slash" : "fa-eye"}`}
          aria-hidden="true"
        />
      </button>
    </span>
  );
};

export default MaskedNationalId;
